export default __webpack_public_path__ + "static/media/people-standing.82b17058.png";